export default "__VITE_ASSET__b6171099__"